import { createSupabaseClient } from "../../../hooks/useSupabase";
import { Customer } from "./types";

const supabaseCustomerRequest = `
id,
first_name,
last_name,
email
`;

const getAppointmentCustomerData = async (id: string) => {
  const supabaseClient = createSupabaseClient();

  const { data, error } = await supabaseClient
    .from("appointment_customer_details")
    .select(supabaseCustomerRequest)
    .eq("id", id)
    .limit(1)
    .maybeSingle<Customer>();

  if (error) throw new Error(error.message);

  return data;
};

export default getAppointmentCustomerData;
